<div class="item-card">
  <img class="item-image"
                    [src]="
                      item.product.productImages &&
                      item.product.productImages.length > 0 &&
                      item.product.productImages[0].url
                        ? item.product.productImages[0].url
                        : 'assets/images/icons/ic_demo_img.svg'
                    "
                  /> -->

  <div class="item-name">{{ getShortProductName(item.product.name ?? '') }}</div>
  <div class="item-location" *ngIf="showLocatoin">Location: {{ item.location }}</div>
</div>

<div class="required-quantity-box">
  <span class="label">{{qtyLable}}</span>
  <span class="quantity-font" style="color: #0C9AEB;"> {{ item.quantity }}</span>
</div>
<div class="d-flex justify-content-between gap-2">
  <div class="picked-quantity-box">
    <span class="label">{{readyLable}}</span>
    <span class="quantity-font" style="color: #12B769;">{{ pickedQuantity }}</span>
  </div>
  <div class="remain-quantity-box">
    <span class="label">{{remainLable}}</span>
    <span class="quantity-font" style="color: #F04438;">{{ item.remainQuantity }}</span>
  </div>
</div>